(() => {
  if (customElements.get('helior-ring-sizes')) return;
  const preferences = new Map();
  const validSystems = ['UK', 'EU', 'US'];
  const storageKey = 'helior:ring-size-system:v1';

  class HeliorRingSizes extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.system = this.preferredSystem();
        this.onClick = (event) => {
          const button = event.target.closest('[data-ring-system]');
          if (!button || !this.contains(button)) return;
          const system = button.dataset.ringSystem;
          if (!validSystems.includes(system)) return;
          preferences.set(this.dataset.country, system);
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({ country: this.dataset.country, system }));
          } catch {}
          document.querySelectorAll('helior-ring-sizes').forEach((picker) => {
            if (picker.dataset.country === this.dataset.country) {
              picker.system = system;
              picker.update();
            }
          });
        };
        this.onChange = () => this.update();
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.update();
        this.querySelector('.helior-ring-sizes__systems').hidden = false;
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.initialized = false;
    }

    preferredSystem() {
      const country = this.dataset.country;
      if (preferences.has(country)) return preferences.get(country);
      try {
        const preference = JSON.parse(sessionStorage.getItem(storageKey));
        if (preference?.country === country && validSystems.includes(preference.system)) return preference.system;
      } catch {}
      return validSystems.includes(this.dataset.defaultSystem) ? this.dataset.defaultSystem : 'US';
    }

    update() {
      if (!validSystems.includes(this.system)) return;
      const key = this.system.toLowerCase();
      this.querySelectorAll('[data-ring-label]').forEach((label) => {
        label.textContent = label.dataset.mapped === 'true'
          ? label.dataset[key].replace(/^(US|UK|EU) /, '')
          : label.dataset[key];
        const radio = label.closest('label')?.previousElementSibling;
        if (radio?.type === 'radio') radio.setAttribute('aria-label', label.dataset[key] + (label.dataset.available === 'false' ? ` — ${label.dataset.unavailable}` : ''));
        if (label.tagName === 'OPTION' && label.dataset.available === 'false') {
          label.textContent += ` — ${label.dataset.unavailable}`;
        }
      });
      this.querySelectorAll('[data-ring-system]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.ringSystem === this.system));
      });
      this.querySelector('[data-ring-system-heading]').textContent = `(${this.system})`;
      const selected = this.querySelector('input[type="radio"]:checked') || this.querySelector('select')?.selectedOptions[0];
      const label = selected?.tagName === 'OPTION'
        ? selected
        : selected?.nextElementSibling?.querySelector('[data-ring-label]');
      const property = this.querySelector('[data-ring-property]');
      const equivalent = this.querySelector('[data-ring-equivalent]');
      if (!label) {
        property.disabled = true;
        property.value = '';
        equivalent.textContent = '';
        return;
      }
      property.value = label.dataset[key] === label.dataset.us
        ? label.dataset.us
        : `${label.dataset[key]} (${label.dataset.us})`;
      property.disabled = false;
      equivalent.textContent = [...new Set([label.dataset.uk, label.dataset.eu, label.dataset.us])]
        .filter((value) => value !== label.dataset[key]).join(' · ');
      if (label.dataset.mapped === 'true' && label.dataset.diameter) {
        equivalent.textContent += ` · ${label.dataset.diameter} mm ${this.dataset.diameterLabel}`;
      }
      equivalent.parentElement.hidden = label.dataset.mapped !== 'true';
    }
  }
  customElements.define('helior-ring-sizes', HeliorRingSizes);
})();
